
import Tasks from './Components/Tasks';;
const App = () => {
  return (
    <div className="container">
      <Tasks/> 
    </div>
  )
}

export default App;

